"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vue$proxy = exports.Vue$dependArray = exports.Vue$isReserved = void 0;
function Vue$isReserved(str) {
    var c = (str + "").charCodeAt(0);
    return c === 0x24 || c === 0x5F;
}
exports.Vue$isReserved = Vue$isReserved;
function Vue$dependArray(value) {
    for (var e, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        e && e.__ob__ && e.__ob__.dep.depend();
        if (Array.isArray(e)) {
            Vue$dependArray(e);
        }
    }
}
exports.Vue$dependArray = Vue$dependArray;
function Vue$proxy(target, sourceKey, key) {
    Object.defineProperty(target, key, {
        configurable: true,
        enumerable: true,
        get: function VueModel$proxyPropertyGet() {
            return this[sourceKey][key];
        },
        set: function VueModel$proxyPropertySet(value) {
            this[sourceKey][key] = value;
        }
    });
}
exports.Vue$proxy = Vue$proxy;
